import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Lodash
import _isFunction from 'lodash/isFunction';

// Constants
import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';

// Helpers
import { defaultFilterOption } from './virtualizedSelect.helpers';

// Components
import MenuPortal from '../advancedSelect/components/MenuPortal';
import MenuList from './components/menuList';
var REACT_SELECT_CUSTOM_COMPONENTS = {
  MenuPortal: MenuPortal,
  MenuList: MenuList
};
var withVirtualized = function withVirtualized(WrappedComponent) {
  var WithVirtualized = /*#__PURE__*/function (_Component) {
    _inherits(WithVirtualized, _Component);
    var _super = _createSuper(WithVirtualized);
    function WithVirtualized() {
      var _this;
      _classCallCheck(this, WithVirtualized);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "filterOptions", function (option, searchText) {
        var filterOption = _this.props.filterOption;
        if (_isFunction(filterOption)) {
          var _isOptionMatched = filterOption(option, searchText);
          return _isOptionMatched;
        }
        var isOptionMatched = defaultFilterOption(option, searchText);
        return isOptionMatched;
      });
      return _this;
    }
    _createClass(WithVirtualized, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, this.props, {
          filterOption: this.filterOptions,
          menuPlacement: "auto"
        }));
      }
    }]);
    return WithVirtualized;
  }(Component);
  WithVirtualized.propTypes = {
    options: PropTypes.array,
    components: PropTypes.array,
    isSearchable: PropTypes.bool,
    filterOption: PropTypes.func
  };
  WithVirtualized.defaultProps = {
    options: EMPTY_ARRAY,
    components: REACT_SELECT_CUSTOM_COMPONENTS,
    isSearchable: true,
    filterOption: undefined
  };
  return WithVirtualized;
};
export default withVirtualized;